module.exports = __webpack_public_path__ + "uarm-images/ui-icons_cc0000_256x240.png";